import script from "./Psicomp.vue?vue&type=script&setup=true&lang=js"
export * from "./Psicomp.vue?vue&type=script&setup=true&lang=js"

import "./Psicomp.vue?vue&type=style&index=0&id=28164b64&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28164b64"]])

export default __exports__